export const PURCHASES_STATUS = [
    { value: 'approved', label: 'Approved' },
    { value: 'invoiced', label: 'Invoiced' },
    { value: 'match', label: 'Match' },
    { value: 'mismatch', label: 'Mismatch' },
]